import cookieService from '../services/Cookies.service';
const gapi = window.gapi;
const SCOPES = 'https://www.googleapis.com/auth/calendar.readonly';
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'];
let gapiResolvers = [];
class GApiWrapper {
  isSignedIn = false;
  currentUser = {};
  auth2;
  attachClickHandler;
  client;
  androidLogin = cookieService.getCookie('androidLogin');
  token = cookieService.getCookie('loginToken');

  init() {
    return new Promise((resolve, reject) => {
      if (!window.gapiLoaded) {
        setTimeout(() => { this.init().then(resolve()); }, 200);
        return;
      }
      if (window.cordova) {
        reject(new Error('Native app'));
      }
      gapi.load('auth2', () => {
        console.log('init');
        gapi.client.init({
          apiKey: 'AIzaSyD_12al-QBdLCJKYOlEyMiGVx63jsVGWqs',
          client_id: '302015321251-ljludv1la4u9ud5mc9uatr0ergamg198.apps.googleusercontent.com',
          discoveryDocs: DISCOVERY_DOCS,
          scope: SCOPES
        }).then((a, b, c) => {
          console.log('then');
          let auth2 = gapi.auth2.getAuthInstance();
          this.attachClickHandler = auth2.attachClickHandler;
          // auth2.attachClickHandler('signin-button', {}, onSuccess, onFailure);
          auth2.isSignedIn.listen((val) => this.signinChanged(val));
          auth2.currentUser.listen((user) => this.userChanged(user)); // This is what you use to listen for user changes
          this.auth2 = auth2;
          this.client = gapi.client;
          console.log('resolve');
          this.getGapiClient().then(console.log);
          resolve();
        });
      });
    });
  }

  getGapiClient() {
    return new Promise((resolve, reject) => {
      if (!!!this.client) {
        gapiResolvers.push(resolve);
      } else {
        for (let i = 0; i < gapiResolvers.length; i++) {
          gapiResolvers[i](this.client);
        }
        gapiResolvers = [];
        resolve(this.client);
      }
    });
  }

  signinChanged(val) {
    this.isSignedIn = val;
  }

  userChanged(user) {
    this.currentUser = user;
  }
  signOut() {
    this.auth2.signOut().then(function () {
      console.log('User signed out.');
    });
  }
}

export default new GApiWrapper();
